export type ActStatus = 'live' | 'upcoming' | 'finished';
export type Stage =
  | 'Musikarena' |'Folkbühne' |'Festivalbühne' |'Kampfplatz' |'Turnierarena' |'Kinderbereich' |'Hinter der Folkbühne' |'Am Badehaus' |'Auf dem Gelände' |'Marktbühne' |'Bühne der Spielleute' |'Auf der Waldwiese' |'Auf der Heerlagerwiese' |'Künstler' | 'Versorgung' | 'Handel' | 'Handwerk' | 'Animation' | 'Heerlager';

export interface Act {
  id: string;
  name: string;
  stage: Stage;
  startTime: string;
  endTime: string;
  genre: string;
  description?: string;
  isHeadliner?: boolean;
}

export interface DaySchedule {
  dayKey: 'thu' | 'fri' | 'sat' | 'sun';
  label: string;
  shortLabel: string;
  date: string;
  openTime: string;
  musikarenaOpen?: string;
  acts: Act[];
  note?: string;
}

export interface MPSEvent {
  id: string;
  name: string;
  location: string;
  city: string;
  dates: string;
  startDate: string;
  endDate: string;
  schedule: DaySchedule[];
  hasMap?: boolean;
}

// Rastede Schedule (14.–17.05.2026) — Daten aus offiziellem Programmheft
const RASTEDE_SCHEDULE: DaySchedule[] = [
  {
    dayKey: 'thu',
    label: 'Donnerstag',
    shortLabel: 'Do',
    date: '14.05.2026',
    openTime: '11:00',
    musikarenaOpen: '14:30',
    acts: [
      // Musikarena / MPS Bühne
      { id: 'ras-thu-m01', name: 'Storm Seeker', stage: 'Musikarena', startTime: '15:30', endTime: '19:00', genre: 'Pirate Metal', isHeadliner: true },
      { id: 'ras-thu-m02', name: 'Versengold', stage: 'Musikarena', startTime: '19:00', endTime: '21:00', genre: 'Mittelalter-Rock', isHeadliner: true },
      { id: 'ras-thu-m03', name: 'Saor Patrol', stage: 'Musikarena', startTime: '21:00', endTime: '23:00', genre: 'Celtic Folk', isHeadliner: true },
      // Folkbühne
      { id: 'ras-thu-f01', name: 'Katerfahrt', stage: 'Folkbühne', startTime: '13:00', endTime: '15:10', genre: 'Mittelalter-Folk' },
      { id: 'ras-thu-f02', name: 'Banished Privateers', stage: 'Folkbühne', startTime: '15:10', endTime: '17:00', genre: 'Pirate Folk' },
      { id: 'ras-thu-f03', name: 'Katerfahrt', stage: 'Folkbühne', startTime: '17:00', endTime: '18:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-thu-f04', name: 'Banished Privateers', stage: 'Folkbühne', startTime: '18:30', endTime: '20:30', genre: 'Pirate Folk' },
      { id: 'ras-thu-f05', name: 'Katerfahrt', stage: 'Folkbühne', startTime: '20:30', endTime: '22:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-thu-f06', name: 'Banished Privateers', stage: 'Folkbühne', startTime: '22:30', endTime: '23:59', genre: 'Pirate Folk' },
      // Festivalbühne
      { id: 'ras-thu-fb01', name: 'Des Bruder Rectus Morgenmesse', stage: 'Festivalbühne', startTime: '11:30', endTime: '12:30', genre: 'Zeremonie' },
      { id: 'ras-thu-fb02', name: 'Mythemia', stage: 'Festivalbühne', startTime: '12:30', endTime: '14:00', genre: 'Mittelalter-Folk' },
      { id: 'ras-thu-fb03', name: 'Deus Vult', stage: 'Festivalbühne', startTime: '14:00', endTime: '16:00', genre: 'Mittelalter' },
      { id: 'ras-thu-fb04', name: 'Mythemia', stage: 'Festivalbühne', startTime: '16:00', endTime: '17:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-thu-fb05', name: 'Mythemia', stage: 'Festivalbühne', startTime: '17:30', endTime: '19:00', genre: 'Mittelalter-Folk' },
      { id: 'ras-thu-fb06', name: 'Deus Vult', stage: 'Festivalbühne', startTime: '19:00', endTime: '20:30', genre: 'Mittelalter' },
      { id: 'ras-thu-fb07', name: 'Mythemia', stage: 'Festivalbühne', startTime: '20:30', endTime: '22:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-thu-fb08', name: 'Deus Vult', stage: 'Festivalbühne', startTime: '22:30', endTime: '23:59', genre: 'Mittelalter' },
      // Kampfplatz
      { id: 'ras-thu-kp01', name: 'Fictum', stage: 'Kampfplatz', startTime: '13:00', endTime: '14:30', genre: 'Schaukampf' },
      { id: 'ras-thu-kp02', name: 'Fictum', stage: 'Kampfplatz', startTime: '14:30', endTime: '15:00', genre: 'Schaukampf' },
      { id: 'ras-thu-kp03', name: 'Märchenstunde', stage: 'Kampfplatz', startTime: '15:00', endTime: '16:00', genre: 'Märchen & Geschichten' },
      { id: 'ras-thu-kp04', name: 'Fictum', stage: 'Kampfplatz', startTime: '16:00', endTime: '16:30', genre: 'Schaukampf' },
      { id: 'ras-thu-kp05', name: 'Tanzworkshop', stage: 'Kampfplatz', startTime: '16:30', endTime: '17:00', genre: 'Tanz' },
      { id: 'ras-thu-kp06', name: 'Tanz der Marktleute', stage: 'Kampfplatz', startTime: '17:00', endTime: '17:30', genre: 'Tanz & Folklore' },
      { id: 'ras-thu-kp07', name: 'Fictum', stage: 'Kampfplatz', startTime: '17:30', endTime: '18:00', genre: 'Schaukampf' },
      { id: 'ras-thu-kp08', name: 'Bruchenballturnier', stage: 'Kampfplatz', startTime: '18:00', endTime: '19:00', genre: 'Turnier' },
      { id: 'ras-thu-kp09', name: 'Fictum', stage: 'Kampfplatz', startTime: '19:00', endTime: '20:00', genre: 'Schaukampf' },
      { id: 'ras-thu-kp10', name: 'DHDS Wahrheiten und Anderes', stage: 'Kampfplatz', startTime: '20:00', endTime: '21:30', genre: 'Spoken Word' },
      { id: 'ras-thu-kp11', name: 'Die Feuershow', stage: 'Kampfplatz', startTime: '21:30', endTime: '23:00', genre: 'Feuershow' },
      // Turnierarena
      { id: 'ras-thu-ta01', name: 'EHS Team', stage: 'Turnierarena', startTime: '14:30', endTime: '17:00', genre: 'Schaukampf' },
      { id: 'ras-thu-ta02', name: 'EHS Team', stage: 'Turnierarena', startTime: '17:00', endTime: '19:30', genre: 'Schaukampf' },
      { id: 'ras-thu-ta03', name: 'EHS Team', stage: 'Turnierarena', startTime: '19:30', endTime: '22:00', genre: 'Schaukampf' },
      // Hinter der Folkbühne
      { id: 'ras-thu-hf01', name: 'Orlando von Godenhaven', stage: 'Hinter der Folkbühne', startTime: '12:30', endTime: '13:00', genre: 'Mittelalter' },
      { id: 'ras-thu-hf02', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '13:00', endTime: '15:00', genre: 'Mittelalter-Folk' },
      { id: 'ras-thu-hf03', name: 'Orlando von Godenhaven', stage: 'Hinter der Folkbühne', startTime: '15:00', endTime: '15:30', genre: 'Mittelalter' },
      { id: 'ras-thu-hf04', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '15:30', endTime: '17:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-thu-hf05', name: 'Orlando von Godenhaven', stage: 'Hinter der Folkbühne', startTime: '17:30', endTime: '18:30', genre: 'Mittelalter' },
      { id: 'ras-thu-hf06', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '18:30', endTime: '19:00', genre: 'Mittelalter-Folk' },
      { id: 'ras-thu-hf07', name: 'Orlando von Godenhaven', stage: 'Hinter der Folkbühne', startTime: '19:00', endTime: '21:30', genre: 'Mittelalter' },
      { id: 'ras-thu-hf08', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '21:30', endTime: '23:59', genre: 'Mittelalter-Folk' },
      // Am Badehaus
      { id: 'ras-thu-ab01', name: 'Bagatelli', stage: 'Am Badehaus', startTime: '13:30', endTime: '16:00', genre: 'Mittelalter-Unterhaltung' },
      { id: 'ras-thu-ab02', name: 'Bagatelli', stage: 'Am Badehaus', startTime: '16:00', endTime: '18:30', genre: 'Mittelalter-Unterhaltung' },
      { id: 'ras-thu-ab03', name: 'Bagatelli', stage: 'Am Badehaus', startTime: '18:30', endTime: '20:30', genre: 'Mittelalter-Unterhaltung' },
      { id: 'ras-thu-ab04', name: 'Bagatelli', stage: 'Am Badehaus', startTime: '20:30', endTime: '23:00', genre: 'Mittelalter-Unterhaltung' },
      // Auf dem Gelände unterwegs
      { id: 'ras-thu-g01', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '13:30', endTime: '14:00', genre: 'Straßentheater' },
      { id: 'ras-thu-g02', name: 'Liam Bo Skol', stage: 'Auf dem Gelände', startTime: '14:00', endTime: '14:30', genre: 'Straßenmusik' },
      { id: 'ras-thu-g03', name: 'Paritae Windpferde', stage: 'Auf dem Gelände', startTime: '14:30', endTime: '15:30', genre: 'Pferdeshow' },
      { id: 'ras-thu-g04', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '15:30', endTime: '16:00', genre: 'Straßentheater' },
      { id: 'ras-thu-g05', name: 'Liam Bo Skol', stage: 'Auf dem Gelände', startTime: '16:00', endTime: '16:30', genre: 'Straßenmusik' },
      { id: 'ras-thu-g06', name: 'Paritae Windpferde', stage: 'Auf dem Gelände', startTime: '16:30', endTime: '17:00', genre: 'Pferdeshow' },
      { id: 'ras-thu-g07', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '17:00', endTime: '17:30', genre: 'Straßentheater' },
      { id: 'ras-thu-g08', name: 'Großer Umzug der Heerlager', stage: 'Auf dem Gelände', startTime: '17:30', endTime: '18:30', genre: 'Parade' },
      { id: 'ras-thu-g09', name: 'Paritae Windpferde', stage: 'Auf dem Gelände', startTime: '18:30', endTime: '19:00', genre: 'Pferdeshow' },
      { id: 'ras-thu-g10', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '19:00', endTime: '19:30', genre: 'Straßentheater' },
      { id: 'ras-thu-g11', name: 'Liam Bo Skol', stage: 'Auf dem Gelände', startTime: '19:30', endTime: '20:30', genre: 'Straßenmusik' },
      { id: 'ras-thu-g12', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '20:30', endTime: '23:00', genre: 'Straßentheater' },
    ],
  },
  {
    dayKey: 'fri',
    label: 'Freitag',
    shortLabel: 'Fr',
    date: '15.05.2026',
    openTime: '12:00',
    musikarenaOpen: '15:30',
    acts: [
      // Musikarena / MPS Bühne
      { id: 'ras-fri-m01', name: 'Mr. Hurley & die Pulveraffen', stage: 'Musikarena', startTime: '16:30', endTime: '22:00', genre: 'Pirate Folk', isHeadliner: true },
      { id: 'ras-fri-m02', name: 'Saltatio Mortis', stage: 'Musikarena', startTime: '22:00', endTime: '23:59', genre: 'Mittelalter-Metal', isHeadliner: true },
      // Folkbühne
      { id: 'ras-fri-f01', name: 'Ye Banished Privateers', stage: 'Folkbühne', startTime: '13:30', endTime: '15:30', genre: 'Pirate Folk' },
      { id: 'ras-fri-f02', name: 'Ye Banished Privateers', stage: 'Folkbühne', startTime: '15:30', endTime: '17:00', genre: 'Pirate Folk' },
      { id: 'ras-fri-f03', name: 'Katerfahrt', stage: 'Folkbühne', startTime: '17:00', endTime: '18:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-fri-f04', name: 'Ye Banished Privateers', stage: 'Folkbühne', startTime: '18:30', endTime: '21:00', genre: 'Pirate Folk' },
      { id: 'ras-fri-f05', name: 'Mr Irish Bastard', stage: 'Folkbühne', startTime: '21:00', endTime: '22:30', genre: 'Irish Folk' },
      { id: 'ras-fri-f06', name: 'Katerfahrt', stage: 'Folkbühne', startTime: '22:30', endTime: '23:59', genre: 'Mittelalter-Folk' },
      // Festivalbühne
      { id: 'ras-fri-fb01', name: 'Rapalje', stage: 'Festivalbühne', startTime: '13:00', endTime: '14:00', genre: 'Celtic Folk' },
      { id: 'ras-fri-fb02', name: 'Deus Vult', stage: 'Festivalbühne', startTime: '14:00', endTime: '15:30', genre: 'Mittelalter' },
      { id: 'ras-fri-fb03', name: 'Heavy Saurus', stage: 'Festivalbühne', startTime: '15:30', endTime: '17:30', genre: 'Dino-Metal' },
      { id: 'ras-fri-fb04', name: 'Deus Vult', stage: 'Festivalbühne', startTime: '17:30', endTime: '19:00', genre: 'Mittelalter' },
      { id: 'ras-fri-fb05', name: 'Kupfergold', stage: 'Festivalbühne', startTime: '19:00', endTime: '21:00', genre: 'Mittelalter-Folk' },
      { id: 'ras-fri-fb06', name: 'Rapalje', stage: 'Festivalbühne', startTime: '21:00', endTime: '23:00', genre: 'Celtic Folk' },
      { id: 'ras-fri-fb07', name: 'Deus Vult', stage: 'Festivalbühne', startTime: '23:00', endTime: '23:59', genre: 'Mittelalter' },
      // Kampfplatz
      { id: 'ras-fri-kp01', name: 'Fictum', stage: 'Kampfplatz', startTime: '13:00', endTime: '14:30', genre: 'Schaukampf' },
      { id: 'ras-fri-kp02', name: 'Fictum', stage: 'Kampfplatz', startTime: '14:30', endTime: '15:00', genre: 'Schaukampf' },
      { id: 'ras-fri-kp03', name: 'Märchenstunde', stage: 'Kampfplatz', startTime: '15:00', endTime: '16:00', genre: 'Märchen & Geschichten' },
      { id: 'ras-fri-kp04', name: 'Fictum', stage: 'Kampfplatz', startTime: '16:00', endTime: '16:30', genre: 'Schaukampf' },
      { id: 'ras-fri-kp05', name: 'Tanzworkshop', stage: 'Kampfplatz', startTime: '16:30', endTime: '17:00', genre: 'Tanz' },
      { id: 'ras-fri-kp06', name: 'Tanz der Marktleute', stage: 'Kampfplatz', startTime: '17:00', endTime: '17:30', genre: 'Tanz & Folklore' },
      { id: 'ras-fri-kp07', name: 'Fictum', stage: 'Kampfplatz', startTime: '17:30', endTime: '18:00', genre: 'Schaukampf' },
      { id: 'ras-fri-kp08', name: 'Bruchenballturnier', stage: 'Kampfplatz', startTime: '18:00', endTime: '19:00', genre: 'Turnier' },
      { id: 'ras-fri-kp09', name: 'Fictum', stage: 'Kampfplatz', startTime: '19:00', endTime: '20:00', genre: 'Schaukampf' },
      { id: 'ras-fri-kp10', name: 'DHDS Wahrheiten und Anderes', stage: 'Kampfplatz', startTime: '20:00', endTime: '21:30', genre: 'Spoken Word' },
      { id: 'ras-fri-kp11', name: 'Die Feuershow', stage: 'Kampfplatz', startTime: '21:30', endTime: '23:00', genre: 'Feuershow' },
      // Turnierarena
      { id: 'ras-fri-ta01', name: 'EHS Team', stage: 'Turnierarena', startTime: '14:00', endTime: '18:00', genre: 'Schaukampf' },
      { id: 'ras-fri-ta02', name: 'EHS Team', stage: 'Turnierarena', startTime: '18:00', endTime: '23:00', genre: 'Schaukampf' },
      // Hinter der Folkbühne
      { id: 'ras-fri-hf01', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '13:00', endTime: '15:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-fri-hf02', name: 'Mythemia', stage: 'Hinter der Folkbühne', startTime: '15:30', endTime: '16:00', genre: 'Mittelalter-Folk' },
      { id: 'ras-fri-hf03', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '16:00', endTime: '17:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-fri-hf04', name: 'Orlando von Godenhaven', stage: 'Hinter der Folkbühne', startTime: '17:30', endTime: '18:30', genre: 'Mittelalter' },
      { id: 'ras-fri-hf05', name: 'Mythemia', stage: 'Hinter der Folkbühne', startTime: '18:30', endTime: '19:00', genre: 'Mittelalter-Folk' },
      { id: 'ras-fri-hf06', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '19:00', endTime: '19:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-fri-hf07', name: 'Orlando von Godenhaven', stage: 'Hinter der Folkbühne', startTime: '19:30', endTime: '21:00', genre: 'Mittelalter' },
      { id: 'ras-fri-hf08', name: 'Mythemia', stage: 'Hinter der Folkbühne', startTime: '21:00', endTime: '22:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-fri-hf09', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '22:30', endTime: '23:59', genre: 'Mittelalter-Folk' },
      // Am Badehaus
      { id: 'ras-fri-ab01', name: 'Orlando von Godenhaven', stage: 'Am Badehaus', startTime: '13:00', endTime: '14:30', genre: 'Mittelalter' },
      { id: 'ras-fri-ab02', name: 'Orlando von Godenhaven', stage: 'Am Badehaus', startTime: '14:30', endTime: '16:30', genre: 'Mittelalter' },
      { id: 'ras-fri-ab03', name: 'Bagatelli', stage: 'Am Badehaus', startTime: '16:30', endTime: '18:00', genre: 'Mittelalter-Unterhaltung' },
      { id: 'ras-fri-ab04', name: 'Bagatelli', stage: 'Am Badehaus', startTime: '18:00', endTime: '19:30', genre: 'Mittelalter-Unterhaltung' },
      { id: 'ras-fri-ab05', name: 'Bagatelli', stage: 'Am Badehaus', startTime: '19:30', endTime: '21:30', genre: 'Mittelalter-Unterhaltung' },
      { id: 'ras-fri-ab06', name: 'Tir Saor', stage: 'Am Badehaus', startTime: '21:30', endTime: '23:59', genre: 'Celtic Folk' },
      // Auf dem Gelände unterwegs
      { id: 'ras-fri-g01', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '13:00', endTime: '14:00', genre: 'Straßentheater' },
      { id: 'ras-fri-g02', name: 'Paritae Windpferde', stage: 'Auf dem Gelände', startTime: '14:00', endTime: '14:30', genre: 'Pferdeshow' },
      { id: 'ras-fri-g03', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '14:30', endTime: '15:00', genre: 'Straßentheater' },
      { id: 'ras-fri-g04', name: 'Liam Bo Skol', stage: 'Auf dem Gelände', startTime: '15:00', endTime: '16:00', genre: 'Straßenmusik' },
      { id: 'ras-fri-g05', name: 'Paritae Windpferde', stage: 'Auf dem Gelände', startTime: '16:00', endTime: '16:30', genre: 'Pferdeshow' },
      { id: 'ras-fri-g06', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '16:30', endTime: '17:00', genre: 'Straßentheater' },
      { id: 'ras-fri-g07', name: 'Liam Bo Skol', stage: 'Auf dem Gelände', startTime: '17:00', endTime: '17:30', genre: 'Straßenmusik' },
      { id: 'ras-fri-g08', name: 'Großer Umzug der Heerlager', stage: 'Auf dem Gelände', startTime: '17:30', endTime: '18:00', genre: 'Parade' },
      { id: 'ras-fri-g09', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '18:00', endTime: '18:30', genre: 'Straßentheater' },
      { id: 'ras-fri-g10', name: 'Paritae Windpferde', stage: 'Auf dem Gelände', startTime: '18:30', endTime: '19:30', genre: 'Pferdeshow' },
      { id: 'ras-fri-g11', name: 'Liam Bo Skol', stage: 'Auf dem Gelände', startTime: '19:30', endTime: '20:00', genre: 'Straßenmusik' },
      { id: 'ras-fri-g12', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '20:00', endTime: '23:00', genre: 'Straßentheater' },
    ],
  },
  {
    dayKey: 'sat',
    label: 'Samstag',
    shortLabel: 'Sa',
    date: '16.05.2026',
    openTime: '11:00',
    musikarenaOpen: '13:30',
    acts: [
      // Musikarena / MPS Bühne
      { id: 'ras-sat-m01', name: 'Rapalje', stage: 'Musikarena', startTime: '15:00', endTime: '17:00', genre: 'Celtic Folk', isHeadliner: true },
      { id: 'ras-sat-m02', name: 'Saltatio Mortis', stage: 'Musikarena', startTime: '17:00', endTime: '20:00', genre: 'Mittelalter-Metal', isHeadliner: true },
      { id: 'ras-sat-m03', name: 'Knasterbart', stage: 'Musikarena', startTime: '20:00', endTime: '22:30', genre: 'Piraten-Folk', isHeadliner: true },
      { id: 'ras-sat-m04', name: 'Feuerschwanz', stage: 'Musikarena', startTime: '22:30', endTime: '23:59', genre: 'Mittelalter-Metal', isHeadliner: true },
      // Folkbühne
      { id: 'ras-sat-f01', name: 'Katerfahrt', stage: 'Folkbühne', startTime: '12:00', endTime: '13:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-sat-f02', name: 'Die Habenichtse', stage: 'Folkbühne', startTime: '13:30', endTime: '15:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-sat-f03', name: 'Saor Patrol', stage: 'Folkbühne', startTime: '15:30', endTime: '17:00', genre: 'Celtic Folk' },
      { id: 'ras-sat-f04', name: 'Die Habenichtse', stage: 'Folkbühne', startTime: '17:00', endTime: '18:00', genre: 'Mittelalter-Folk' },
      { id: 'ras-sat-f05', name: 'Saor Patrol', stage: 'Folkbühne', startTime: '18:00', endTime: '19:30', genre: 'Celtic Folk' },
      { id: 'ras-sat-f06', name: 'Katerfahrt', stage: 'Folkbühne', startTime: '19:30', endTime: '21:00', genre: 'Mittelalter-Folk' },
      { id: 'ras-sat-f07', name: 'Die Habenichtse', stage: 'Folkbühne', startTime: '21:00', endTime: '22:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-sat-f08', name: 'Saor Patrol', stage: 'Folkbühne', startTime: '22:30', endTime: '23:59', genre: 'Celtic Folk' },
      // Festivalbühne
      { id: 'ras-sat-fb01', name: 'Tir Saor', stage: 'Festivalbühne', startTime: '13:00', endTime: '14:30', genre: 'Celtic Folk' },
      { id: 'ras-sat-fb02', name: 'Harmony Glen', stage: 'Festivalbühne', startTime: '14:30', endTime: '16:00', genre: 'Celtic Folk' },
      { id: 'ras-sat-fb03', name: 'Heavy Saurus', stage: 'Festivalbühne', startTime: '16:00', endTime: '17:30', genre: 'Dino-Metal' },
      { id: 'ras-sat-fb04', name: 'Tir Saor', stage: 'Festivalbühne', startTime: '17:30', endTime: '19:00', genre: 'Celtic Folk' },
      { id: 'ras-sat-fb05', name: 'Harmony Glen', stage: 'Festivalbühne', startTime: '19:00', endTime: '21:00', genre: 'Celtic Folk' },
      { id: 'ras-sat-fb06', name: 'Kupfergold', stage: 'Festivalbühne', startTime: '21:00', endTime: '22:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-sat-fb07', name: 'Harmony Glen', stage: 'Festivalbühne', startTime: '22:30', endTime: '23:59', genre: 'Celtic Folk' },
      // Kampfplatz
      { id: 'ras-sat-kp01', name: 'Fictum', stage: 'Kampfplatz', startTime: '13:00', endTime: '14:30', genre: 'Schaukampf' },
      { id: 'ras-sat-kp02', name: 'Fictum', stage: 'Kampfplatz', startTime: '14:30', endTime: '15:00', genre: 'Schaukampf' },
      { id: 'ras-sat-kp03', name: 'Märchenstunde', stage: 'Kampfplatz', startTime: '15:00', endTime: '16:00', genre: 'Märchen & Geschichten' },
      { id: 'ras-sat-kp04', name: 'Fictum', stage: 'Kampfplatz', startTime: '16:00', endTime: '16:30', genre: 'Schaukampf' },
      { id: 'ras-sat-kp05', name: 'Tanzworkshop', stage: 'Kampfplatz', startTime: '16:30', endTime: '17:00', genre: 'Tanz' },
      { id: 'ras-sat-kp06', name: 'Tanz der Marktleute', stage: 'Kampfplatz', startTime: '17:00', endTime: '17:30', genre: 'Tanz & Folklore' },
      { id: 'ras-sat-kp07', name: 'Fictum', stage: 'Kampfplatz', startTime: '17:30', endTime: '18:00', genre: 'Schaukampf' },
      { id: 'ras-sat-kp08', name: 'Bruchenballturnier', stage: 'Kampfplatz', startTime: '18:00', endTime: '19:00', genre: 'Turnier' },
      { id: 'ras-sat-kp09', name: 'Fictum', stage: 'Kampfplatz', startTime: '19:00', endTime: '20:00', genre: 'Schaukampf' },
      { id: 'ras-sat-kp10', name: 'DHDS Wahrheiten und Anderes', stage: 'Kampfplatz', startTime: '20:00', endTime: '21:30', genre: 'Spoken Word' },
      { id: 'ras-sat-kp11', name: 'Die Feuershow', stage: 'Kampfplatz', startTime: '21:30', endTime: '23:00', genre: 'Feuershow' },
      // Turnierarena
      { id: 'ras-sat-ta01', name: 'EHS Team', stage: 'Turnierarena', startTime: '14:00', endTime: '17:00', genre: 'Schaukampf' },
      { id: 'ras-sat-ta02', name: 'EHS Team', stage: 'Turnierarena', startTime: '17:00', endTime: '19:30', genre: 'Schaukampf' },
      { id: 'ras-sat-ta03', name: 'EHS Team', stage: 'Turnierarena', startTime: '19:30', endTime: '23:00', genre: 'Schaukampf' },
      // Hinter der Folkbühne
      { id: 'ras-sat-hf01', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '13:00', endTime: '15:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-sat-hf02', name: 'Mythemia', stage: 'Hinter der Folkbühne', startTime: '15:30', endTime: '16:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-sat-hf03', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '16:30', endTime: '18:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-sat-hf04', name: 'Mythemia', stage: 'Hinter der Folkbühne', startTime: '18:30', endTime: '19:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-sat-hf05', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '19:30', endTime: '21:00', genre: 'Mittelalter-Folk' },
      { id: 'ras-sat-hf06', name: 'Mythemia', stage: 'Hinter der Folkbühne', startTime: '21:00', endTime: '22:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-sat-hf07', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '22:30', endTime: '23:59', genre: 'Mittelalter-Folk' },
      // Am Badehaus
      { id: 'ras-sat-ab01', name: 'Bagatelli', stage: 'Am Badehaus', startTime: '12:30', endTime: '14:30', genre: 'Mittelalter-Unterhaltung' },
      { id: 'ras-sat-ab02', name: 'Bagatelli', stage: 'Am Badehaus', startTime: '14:30', endTime: '16:30', genre: 'Mittelalter-Unterhaltung' },
      { id: 'ras-sat-ab03', name: 'Bagatelli', stage: 'Am Badehaus', startTime: '16:30', endTime: '18:00', genre: 'Mittelalter-Unterhaltung' },
      { id: 'ras-sat-ab04', name: 'Duivelspack', stage: 'Am Badehaus', startTime: '18:00', endTime: '19:00', genre: 'Mittelalter-Folk' },
      { id: 'ras-sat-ab05', name: 'Bagatelli', stage: 'Am Badehaus', startTime: '19:00', endTime: '21:00', genre: 'Mittelalter-Unterhaltung' },
      { id: 'ras-sat-ab06', name: 'Duivelspack', stage: 'Am Badehaus', startTime: '21:00', endTime: '23:59', genre: 'Mittelalter-Folk' },
      // Auf dem Gelände unterwegs
      { id: 'ras-sat-g01', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '13:30', endTime: '14:00', genre: 'Straßentheater' },
      { id: 'ras-sat-g02', name: 'Liam Bo Skol', stage: 'Auf dem Gelände', startTime: '14:00', endTime: '14:30', genre: 'Straßenmusik' },
      { id: 'ras-sat-g03', name: 'Paritae Windpferde', stage: 'Auf dem Gelände', startTime: '14:30', endTime: '15:30', genre: 'Pferdeshow' },
      { id: 'ras-sat-g04', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '15:30', endTime: '16:00', genre: 'Straßentheater' },
      { id: 'ras-sat-g05', name: 'Liam Bo Skol', stage: 'Auf dem Gelände', startTime: '16:00', endTime: '16:30', genre: 'Straßenmusik' },
      { id: 'ras-sat-g06', name: 'Paritae Windpferde', stage: 'Auf dem Gelände', startTime: '16:30', endTime: '17:00', genre: 'Pferdeshow' },
      { id: 'ras-sat-g07', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '17:00', endTime: '17:30', genre: 'Straßentheater' },
      { id: 'ras-sat-g08', name: 'Großer Umzug der Heerlager', stage: 'Auf dem Gelände', startTime: '17:30', endTime: '18:00', genre: 'Parade' },
      { id: 'ras-sat-g09', name: 'Liam Bo Skol', stage: 'Auf dem Gelände', startTime: '18:00', endTime: '18:30', genre: 'Straßenmusik' },
      { id: 'ras-sat-g10', name: 'Paritae Windpferde', stage: 'Auf dem Gelände', startTime: '18:30', endTime: '19:00', genre: 'Pferdeshow' },
      { id: 'ras-sat-g11', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '19:00', endTime: '20:30', genre: 'Straßentheater' },
      { id: 'ras-sat-g12', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '20:30', endTime: '23:00', genre: 'Straßentheater' },
    ],
  },
  {
    dayKey: 'sun',
    label: 'Sonntag',
    shortLabel: 'So',
    date: '17.05.2026',
    openTime: '11:00',
    note: 'Musikarena am Sonntag geschlossen · Markt & Bühnen bis 19:00 Uhr',
    acts: [
      // Folkbühne
      { id: 'ras-sun-f01', name: 'Des Bruder Rectus Morgenmesse', stage: 'Folkbühne', startTime: '11:30', endTime: '12:30', genre: 'Zeremonie' },
      { id: 'ras-sun-f02', name: 'Saor Patrol', stage: 'Folkbühne', startTime: '12:30', endTime: '14:30', genre: 'Celtic Folk' },
      { id: 'ras-sun-f03', name: 'Saor Patrol', stage: 'Folkbühne', startTime: '14:30', endTime: '16:30', genre: 'Celtic Folk' },
      { id: 'ras-sun-f04', name: 'Saor Patrol', stage: 'Folkbühne', startTime: '16:30', endTime: '18:00', genre: 'Celtic Folk' },
      { id: 'ras-sun-f05', name: 'Rapalje', stage: 'Folkbühne', startTime: '18:00', endTime: '19:30', genre: 'Celtic Folk' },
      // Festivalbühne
      { id: 'ras-sun-fb01', name: 'Tir Saor', stage: 'Festivalbühne', startTime: '12:30', endTime: '13:30', genre: 'Celtic Folk' },
      { id: 'ras-sun-fb02', name: 'Harmony Glen', stage: 'Festivalbühne', startTime: '13:30', endTime: '15:30', genre: 'Celtic Folk' },
      { id: 'ras-sun-fb03', name: 'Heavy Saurus', stage: 'Festivalbühne', startTime: '15:30', endTime: '17:00', genre: 'Dino-Metal' },
      { id: 'ras-sun-fb04', name: 'Harmony Glen', stage: 'Festivalbühne', startTime: '17:00', endTime: '18:00', genre: 'Celtic Folk' },
      { id: 'ras-sun-fb05', name: 'Tir Saor', stage: 'Festivalbühne', startTime: '18:00', endTime: '19:30', genre: 'Celtic Folk' },
      // Kampfplatz
      { id: 'ras-sun-kp01', name: 'Fictum', stage: 'Kampfplatz', startTime: '12:00', endTime: '12:30', genre: 'Schaukampf' },
      { id: 'ras-sun-kp02', name: 'Tanzworkshop', stage: 'Kampfplatz', startTime: '12:30', endTime: '13:00', genre: 'Tanz' },
      { id: 'ras-sun-kp03', name: 'Tanz der Marktleute', stage: 'Kampfplatz', startTime: '13:00', endTime: '13:30', genre: 'Tanz & Folklore' },
      { id: 'ras-sun-kp04', name: 'Fictum', stage: 'Kampfplatz', startTime: '13:30', endTime: '14:00', genre: 'Schaukampf' },
      { id: 'ras-sun-kp05', name: 'Märchenstunde', stage: 'Kampfplatz', startTime: '14:00', endTime: '15:00', genre: 'Märchen & Geschichten' },
      { id: 'ras-sun-kp06', name: 'Fictum', stage: 'Kampfplatz', startTime: '15:00', endTime: '15:30', genre: 'Schaukampf' },
      { id: 'ras-sun-kp07', name: 'Bruchenballturnier', stage: 'Kampfplatz', startTime: '15:30', endTime: '16:30', genre: 'Turnier' },
      { id: 'ras-sun-kp08', name: 'Fictum', stage: 'Kampfplatz', startTime: '16:30', endTime: '17:30', genre: 'Schaukampf' },
      { id: 'ras-sun-kp09', name: 'Fictum', stage: 'Kampfplatz', startTime: '17:30', endTime: '19:00', genre: 'Schaukampf' },
      // Turnierarena
      { id: 'ras-sun-ta01', name: 'EHS Team', stage: 'Turnierarena', startTime: '13:00', endTime: '17:00', genre: 'Schaukampf' },
      { id: 'ras-sun-ta02', name: 'EHS Team', stage: 'Turnierarena', startTime: '17:00', endTime: '19:30', genre: 'Schaukampf' },
      // Hinter der Folkbühne
      { id: 'ras-sun-hf01', name: 'Orlando von Godenhaven', stage: 'Hinter der Folkbühne', startTime: '12:00', endTime: '12:30', genre: 'Mittelalter' },
      { id: 'ras-sun-hf02', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '12:30', endTime: '14:00', genre: 'Mittelalter-Folk' },
      { id: 'ras-sun-hf03', name: 'Orlando von Godenhaven', stage: 'Hinter der Folkbühne', startTime: '14:00', endTime: '14:30', genre: 'Mittelalter' },
      { id: 'ras-sun-hf04', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '14:30', endTime: '15:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-sun-hf05', name: 'Orlando von Godenhaven', stage: 'Hinter der Folkbühne', startTime: '15:30', endTime: '16:00', genre: 'Mittelalter' },
      { id: 'ras-sun-hf06', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '16:00', endTime: '17:00', genre: 'Mittelalter-Folk' },
      { id: 'ras-sun-hf07', name: 'Orlando von Godenhaven', stage: 'Hinter der Folkbühne', startTime: '17:00', endTime: '17:30', genre: 'Mittelalter' },
      { id: 'ras-sun-hf08', name: 'Comes Vagantes', stage: 'Hinter der Folkbühne', startTime: '17:30', endTime: '19:00', genre: 'Mittelalter-Folk' },
      // Am Badehaus
      { id: 'ras-sun-ab01', name: 'Bagatelli', stage: 'Am Badehaus', startTime: '12:00', endTime: '14:00', genre: 'Mittelalter-Unterhaltung' },
      { id: 'ras-sun-ab02', name: 'Bagatelli', stage: 'Am Badehaus', startTime: '14:00', endTime: '15:30', genre: 'Mittelalter-Unterhaltung' },
      { id: 'ras-sun-ab03', name: 'Duivelspack', stage: 'Am Badehaus', startTime: '15:30', endTime: '17:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-sun-ab04', name: 'Duivelspack', stage: 'Am Badehaus', startTime: '17:30', endTime: '18:30', genre: 'Mittelalter-Folk' },
      { id: 'ras-sun-ab05', name: 'Bagatelli', stage: 'Am Badehaus', startTime: '18:30', endTime: '19:30', genre: 'Mittelalter-Unterhaltung' },
      // Auf dem Gelände unterwegs
      { id: 'ras-sun-g01', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '12:00', endTime: '13:00', genre: 'Straßentheater' },
      { id: 'ras-sun-g02', name: 'Liam Bo Skol', stage: 'Auf dem Gelände', startTime: '13:00', endTime: '13:30', genre: 'Straßenmusik' },
      { id: 'ras-sun-g03', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '13:30', endTime: '14:30', genre: 'Straßentheater' },
      { id: 'ras-sun-g04', name: 'Großer Umzug der Heerlager', stage: 'Auf dem Gelände', startTime: '14:30', endTime: '15:00', genre: 'Parade' },
      { id: 'ras-sun-g05', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '15:00', endTime: '15:30', genre: 'Straßentheater' },
      { id: 'ras-sun-g06', name: 'Liam Bo Skol', stage: 'Auf dem Gelände', startTime: '15:30', endTime: '16:30', genre: 'Straßenmusik' },
      { id: 'ras-sun-g07', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '16:30', endTime: '17:30', genre: 'Straßentheater' },
      { id: 'ras-sun-g08', name: 'Liam Bo Skol', stage: 'Auf dem Gelände', startTime: '17:30', endTime: '18:00', genre: 'Straßenmusik' },
      { id: 'ras-sun-g09', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '18:00', endTime: '19:30', genre: 'Straßentheater' },
    ],
  },
];

// Bad Säckingen Schedule (25.+26.04.2026)
const BAD_SAECKINGEN_SCHEDULE: DaySchedule[] = [
  {
    dayKey: 'sat',
    label: 'Samstag',
    shortLabel: 'Sa',
    date: '25.04.2026',
    openTime: '11:00',
    musikarenaOpen: '13:00',
    acts: [
      { id: 'bsa-sat-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '18:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
  {
    dayKey: 'sun',
    label: 'Sonntag',
    shortLabel: 'So',
    date: '26.04.2026',
    openTime: '11:00',
    acts: [
      { id: 'bsa-sun-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '18:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
];

// Gut Emkendorf Schedule (23.–25.05.2026)
const GUT_EMKENDORF_SCHEDULE: DaySchedule[] = [
  {
    dayKey: 'sat',
    label: 'Samstag',
    shortLabel: 'Sa',
    date: '23.05.2026',
    openTime: '11:00',
    musikarenaOpen: '13:00',
    acts: [
      { id: 'gem-sat-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '22:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
  {
    dayKey: 'sun',
    label: 'Sonntag',
    shortLabel: 'So',
    date: '24.05.2026',
    openTime: '11:00',
    acts: [
      { id: 'gem-sun-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '22:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
  {
    dayKey: 'thu',
    label: 'Montag',
    shortLabel: 'Mo',
    date: '25.05.2026',
    openTime: '11:00',
    acts: [
      { id: 'gem-mon-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '18:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
];

// Bückeburg I Schedule (25.+26.07.2026)
const BUECKEBURG1_SCHEDULE: DaySchedule[] = [
  {
    dayKey: 'sat',
    label: 'Samstag',
    shortLabel: 'Sa',
    date: '25.07.2026',
    openTime: '11:00',
    musikarenaOpen: '13:00',
    acts: [
      { id: 'bue1-sat-001', name: 'Morgenmesse des Bruder Rectus', stage: 'Festivalbühne', startTime: '11:30', endTime: '12:30', genre: 'Zeremonie' },
      { id: 'bue1-sat-002', name: 'Musikalischer Auftritt', stage: 'Bühne der Spielleute', startTime: '11:30', endTime: '12:30', genre: 'Mittelalter-Musik' },
      { id: 'bue1-sat-003', name: 'Programmbeginn', stage: 'Auf der Waldwiese', startTime: '12:00', endTime: '13:00', genre: 'Programm' },
      { id: 'bue1-sat-004', name: 'Musikalischer Auftritt', stage: 'Bühne der Spielleute', startTime: '12:30', endTime: '13:30', genre: 'Mittelalter-Musik' },
      { id: 'bue1-sat-005', name: 'Einlass', stage: 'Musikarena', startTime: '13:00', endTime: '14:00', genre: 'Einlass' },
      { id: 'bue1-sat-006', name: 'Programmbeginn', stage: 'Am Badehaus', startTime: '13:30', endTime: '14:30', genre: 'Programm' },
      { id: 'bue1-sat-007', name: 'RaptoRex (Dinosaurier)', stage: 'Auf dem Gelände', startTime: '13:30', endTime: '14:30', genre: 'Straßentheater' },
      { id: 'bue1-sat-008', name: 'Mr. Hurley & Die Pulveraffen', stage: 'Musikarena', startTime: '14:00', endTime: '15:00', genre: 'Pirate Folk', isHeadliner: true },
      { id: 'bue1-sat-009', name: 'EHS Team Ritterturnier', stage: 'Turnierarena', startTime: '14:00', endTime: '15:00', genre: 'Schaukampf' },
      { id: 'bue1-sat-010', name: 'Gaukler Bagatelli', stage: 'Auf der Heerlagerwiese', startTime: '14:00', endTime: '14:30', genre: 'Gauklerei' },
      { id: 'bue1-sat-011', name: 'Timelino', stage: 'Kinderbereich', startTime: '14:00', endTime: '14:30', genre: 'Kinderprogramm' },
      { id: 'bue1-sat-012', name: 'Sandsacks', stage: 'Bühne der Spielleute', startTime: '14:30', endTime: '15:30', genre: 'Mittelalter-Musik' },
      { id: 'bue1-sat-013', name: 'Weltenkrieger', stage: 'Auf der Heerlagerwiese', startTime: '15:00', endTime: '15:30', genre: 'Schaukampf' },
      { id: 'bue1-sat-014', name: 'Versengold', stage: 'Festivalbühne', startTime: '15:30', endTime: '16:30', genre: 'Mittelalter-Rock', isHeadliner: true },
      { id: 'bue1-sat-015', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '15:30', endTime: '16:00', genre: 'Straßentheater' },
      { id: 'bue1-sat-016', name: 'Gaukler Bagatelli', stage: 'Auf der Heerlagerwiese', startTime: '16:00', endTime: '16:30', genre: 'Gauklerei' },
      { id: 'bue1-sat-017', name: 'Timelino', stage: 'Kinderbereich', startTime: '16:00', endTime: '16:30', genre: 'Kinderprogramm' },
      { id: 'bue1-sat-018', name: 'Großer Umzug der Heerlager', stage: 'Auf dem Gelände', startTime: '16:00', endTime: '16:30', genre: 'Parade' },
      { id: 'bue1-sat-019', name: 'Faun', stage: 'Festivalbühne', startTime: '16:30', endTime: '17:30', genre: 'Mittelalter-Folk', isHeadliner: true },
      { id: 'bue1-sat-020', name: 'EHS Team', stage: 'Turnierarena', startTime: '17:00', endTime: '17:30', genre: 'Schaukampf' },
      { id: 'bue1-sat-021', name: 'Heavysaurus', stage: 'Festivalbühne', startTime: '17:30', endTime: '18:30', genre: 'Dino-Metal', isHeadliner: true },
      { id: 'bue1-sat-022', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '17:30', endTime: '18:00', genre: 'Straßentheater' },
      { id: 'bue1-sat-023', name: 'Gaukler Bagatelli', stage: 'Auf der Heerlagerwiese', startTime: '18:00', endTime: '18:30', genre: 'Gauklerei' },
      { id: 'bue1-sat-024', name: 'Timelino', stage: 'Kinderbereich', startTime: '18:00', endTime: '18:30', genre: 'Kinderprogramm' },
      { id: 'bue1-sat-025', name: 'Duivelspack', stage: 'Bühne der Spielleute', startTime: '18:30', endTime: '19:30', genre: 'Mittelalter-Folk' },
      { id: 'bue1-sat-026', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '19:00', endTime: '19:30', genre: 'Straßentheater' },
      { id: 'bue1-sat-027', name: 'Timelino', stage: 'Kinderbereich', startTime: '19:30', endTime: '20:00', genre: 'Kinderprogramm' },
      { id: 'bue1-sat-028', name: 'EHS Team (Nachtturnier)', stage: 'Turnierarena', startTime: '20:00', endTime: '21:00', genre: 'Schaukampf' },
      { id: 'bue1-sat-029', name: 'Gaukler Bagatelli', stage: 'Auf der Heerlagerwiese', startTime: '20:00', endTime: '21:00', genre: 'Gauklerei' },
      { id: 'bue1-sat-030', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '20:30', endTime: '21:00', genre: 'Straßentheater' },
      { id: 'bue1-sat-031', name: 'Weltenkrieger', stage: 'Auf der Heerlagerwiese', startTime: '21:00', endTime: '22:00', genre: 'Schaukampf' },
      { id: 'bue1-sat-032', name: 'Saltatio Mortis', stage: 'Musikarena', startTime: '22:00', endTime: '23:30', genre: 'Mittelalter-Metal', isHeadliner: true },
      { id: 'bue1-sat-033', name: 'Heavysaurus', stage: 'Festivalbühne', startTime: '22:30', endTime: '23:30', genre: 'Dino-Metal' },
    ],
  },
  {
    dayKey: 'sun',
    label: 'Sonntag',
    shortLabel: 'So',
    date: '26.07.2026',
    openTime: '11:00',
    acts: [
      { id: 'bue1-sun-001', name: 'Morgenmesse des Bruder Rectus', stage: 'Musikarena', startTime: '11:30', endTime: '12:30', genre: 'Zeremonie' },
      { id: 'bue1-sun-002', name: 'Mr. Hurley & Die Pulveraffen', stage: 'Musikarena', startTime: '12:00', endTime: '13:00', genre: 'Pirate Folk', isHeadliner: true },
      { id: 'bue1-sun-003', name: 'Saor Patrol', stage: 'Festivalbühne', startTime: '12:00', endTime: '13:00', genre: 'Celtic Folk', isHeadliner: true },
      { id: 'bue1-sun-004', name: 'Duivelspack & Sandsacks', stage: 'Bühne der Spielleute', startTime: '12:00', endTime: '13:00', genre: 'Mittelalter-Folk' },
      { id: 'bue1-sun-005', name: 'Weltenkrieger', stage: 'Auf der Heerlagerwiese', startTime: '12:00', endTime: '12:30', genre: 'Schaukampf' },
      { id: 'bue1-sun-006', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '12:00', endTime: '12:30', genre: 'Straßentheater' },
      { id: 'bue1-sun-007', name: 'EHS Team', stage: 'Turnierarena', startTime: '12:30', endTime: '13:30', genre: 'Schaukampf' },
      { id: 'bue1-sun-008', name: 'Timelino', stage: 'Kinderbereich', startTime: '13:00', endTime: '13:30', genre: 'Kinderprogramm' },
      { id: 'bue1-sun-009', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '13:30', endTime: '14:00', genre: 'Straßentheater' },
      { id: 'bue1-sun-010', name: 'Gaukler Bagatelli', stage: 'Auf der Heerlagerwiese', startTime: '14:00', endTime: '14:30', genre: 'Gauklerei' },
      { id: 'bue1-sun-011', name: 'Tir Saor', stage: 'Auf der Waldwiese', startTime: '14:30', endTime: '15:30', genre: 'Celtic Folk' },
      { id: 'bue1-sun-012', name: 'Timelino', stage: 'Kinderbereich', startTime: '14:30', endTime: '15:00', genre: 'Kinderprogramm' },
      { id: 'bue1-sun-013', name: 'Heavysaurus', stage: 'Musikarena', startTime: '15:00', endTime: '16:00', genre: 'Dino-Metal', isHeadliner: true },
      { id: 'bue1-sun-014', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '15:00', endTime: '15:30', genre: 'Straßentheater' },
      { id: 'bue1-sun-015', name: 'Duivelspack', stage: 'Bühne der Spielleute', startTime: '16:00', endTime: '17:00', genre: 'Mittelalter-Folk' },
      { id: 'bue1-sun-016', name: 'EHS Team', stage: 'Turnierarena', startTime: '16:00', endTime: '17:00', genre: 'Schaukampf' },
      { id: 'bue1-sun-017', name: 'Weltenkrieger', stage: 'Auf der Heerlagerwiese', startTime: '16:00', endTime: '17:00', genre: 'Schaukampf' },
      { id: 'bue1-sun-018', name: 'Timelino', stage: 'Kinderbereich', startTime: '16:00', endTime: '16:30', genre: 'Kinderprogramm' },
      { id: 'bue1-sun-019', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '16:30', endTime: '17:00', genre: 'Straßentheater' },
      { id: 'bue1-sun-020', name: 'Heiter bis Folkig', stage: 'Auf der Heerlagerwiese', startTime: '17:00', endTime: '17:30', genre: 'Folk' },
      { id: 'bue1-sun-021', name: 'Großer Umzug der Heerlager', stage: 'Auf dem Gelände', startTime: '17:00', endTime: '17:30', genre: 'Parade' },
      { id: 'bue1-sun-022', name: 'Sandsacks', stage: 'Bühne der Spielleute', startTime: '17:30', endTime: '18:30', genre: 'Mittelalter-Musik' },
      { id: 'bue1-sun-023', name: 'Timelino', stage: 'Kinderbereich', startTime: '17:30', endTime: '18:00', genre: 'Kinderprogramm' },
      { id: 'bue1-sun-024', name: 'RaptoRex', stage: 'Auf dem Gelände', startTime: '17:30', endTime: '18:00', genre: 'Straßentheater' },
      { id: 'bue1-sun-025', name: 'Gaukler Bagatelli', stage: 'Auf der Heerlagerwiese', startTime: '18:00', endTime: '18:30', genre: 'Gauklerei' },
      { id: 'bue1-sun-026', name: 'Saor Patrol', stage: 'Festivalbühne', startTime: '18:30', endTime: '19:30', genre: 'Celtic Folk', isHeadliner: true },
    ],
  },
];

// Bückeburg II Schedule (01.+02.08.2026)
const BUECKEBURG2_SCHEDULE: DaySchedule[] = [
  {
    dayKey: 'sat',
    label: 'Samstag',
    shortLabel: 'Sa',
    date: '01.08.2026',
    openTime: '11:00',
    musikarenaOpen: '13:00',
    acts: [
      { id: 'bue2-sat-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '22:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
  {
    dayKey: 'sun',
    label: 'Sonntag',
    shortLabel: 'So',
    date: '02.08.2026',
    openTime: '11:00',
    acts: [
      { id: 'bue2-sun-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '18:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
];

// Weil am Rhein Schedule (14.–16.08.2026)
const WEIL_AM_RHEIN_SCHEDULE: DaySchedule[] = [
  {
    dayKey: 'fri',
    label: 'Freitag',
    shortLabel: 'Fr',
    date: '14.08.2026',
    openTime: '13:00',
    musikarenaOpen: '16:00',
    acts: [
      { id: 'war-fri-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '13:00', endTime: '23:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
  {
    dayKey: 'sat',
    label: 'Samstag',
    shortLabel: 'Sa',
    date: '15.08.2026',
    openTime: '11:00',
    musikarenaOpen: '13:00',
    acts: [
      { id: 'war-sat-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '23:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
  {
    dayKey: 'sun',
    label: 'Sonntag',
    shortLabel: 'So',
    date: '16.08.2026',
    openTime: '11:00',
    acts: [
      { id: 'war-sun-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '18:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
];

// Speyer Schedule (22.+23.08.2026)
const SPEYER_SCHEDULE: DaySchedule[] = [
  {
    dayKey: 'sat',
    label: 'Samstag',
    shortLabel: 'Sa',
    date: '22.08.2026',
    openTime: '11:00',
    musikarenaOpen: '13:00',
    acts: [
      { id: 'spe-sat-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '22:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
  {
    dayKey: 'sun',
    label: 'Sonntag',
    shortLabel: 'So',
    date: '23.08.2026',
    openTime: '11:00',
    acts: [
      { id: 'spe-sun-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '18:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
];

// Luhmühlen Schedule (04.–06.09.2026)
const LUHMUEHLEN_SCHEDULE: DaySchedule[] = [
  {
    dayKey: 'fri',
    label: 'Freitag',
    shortLabel: 'Fr',
    date: '04.09.2026',
    openTime: '13:00',
    musikarenaOpen: '16:00',
    acts: [
      { id: 'luh-fri-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '13:00', endTime: '23:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
  {
    dayKey: 'sat',
    label: 'Samstag',
    shortLabel: 'Sa',
    date: '05.09.2026',
    openTime: '11:00',
    musikarenaOpen: '13:00',
    acts: [
      { id: 'luh-sat-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '23:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
  {
    dayKey: 'sun',
    label: 'Sonntag',
    shortLabel: 'So',
    date: '06.09.2026',
    openTime: '11:00',
    acts: [
      { id: 'luh-sun-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '18:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
];

// Borken Schedule (26.+27.09.2026)
const BORKEN_SCHEDULE: DaySchedule[] = [
  {
    dayKey: 'sat',
    label: 'Samstag',
    shortLabel: 'Sa',
    date: '26.09.2026',
    openTime: '11:00',
    musikarenaOpen: '13:00',
    acts: [
      { id: 'bor-sat-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '22:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
  {
    dayKey: 'sun',
    label: 'Sonntag',
    shortLabel: 'So',
    date: '27.09.2026',
    openTime: '11:00',
    acts: [
      { id: 'bor-sun-001', name: 'Programm wird bekannt gegeben', stage: 'Marktbühne', startTime: '11:00', endTime: '18:00', genre: 'Mittelalter' },
    ],
    note: 'Spielplan wird noch bekannt gegeben',
  },
];

export const MPS_EVENTS: MPSEvent[] = [
  {
    id: 'bad-saeckingen-2026',
    name: 'MPS Bad Säckingen',
    location: 'Bad Säckingen',
    city: 'Bad Säckingen',
    dates: '25.+26.04.2026',
    startDate: '2026-04-25',
    endDate: '2026-04-26',
    schedule: BAD_SAECKINGEN_SCHEDULE,
  },
  {
    id: 'rastede-2026',
    name: 'MPS Rastede',
    location: 'Schlosspark Rastede',
    city: 'Rastede',
    dates: '14.–17.05.2026',
    startDate: '2026-05-14',
    endDate: '2026-05-17',
    schedule: RASTEDE_SCHEDULE,
    hasMap: true,
  },
  {
    id: 'gut-emkendorf-2026',
    name: 'MPS Gut Emkendorf',
    location: 'Gut Emkendorf',
    city: 'Gut Emkendorf',
    dates: '23.–25.05.2026',
    startDate: '2026-05-23',
    endDate: '2026-05-25',
    schedule: GUT_EMKENDORF_SCHEDULE,
  },
  {
    id: 'bueckeburg1-2026',
    name: 'MPS Bückeburg I',
    location: 'Bückeburg',
    city: 'Bückeburg',
    dates: '25.+26.07.2026',
    startDate: '2026-07-25',
    endDate: '2026-07-26',
    schedule: BUECKEBURG1_SCHEDULE,
  },
  {
    id: 'bueckeburg2-2026',
    name: 'MPS Bückeburg II',
    location: 'Bückeburg',
    city: 'Bückeburg',
    dates: '01.+02.08.2026',
    startDate: '2026-08-01',
    endDate: '2026-08-02',
    schedule: BUECKEBURG2_SCHEDULE,
  },
  {
    id: 'weil-am-rhein-2026',
    name: 'MPS Weil am Rhein',
    location: 'Weil am Rhein',
    city: 'Weil am Rhein',
    dates: '14.–16.08.2026',
    startDate: '2026-08-14',
    endDate: '2026-08-16',
    schedule: WEIL_AM_RHEIN_SCHEDULE,
  },
  {
    id: 'speyer-2026',
    name: 'MPS Speyer',
    location: 'Speyer',
    city: 'Speyer',
    dates: '22.+23.08.2026',
    startDate: '2026-08-22',
    endDate: '2026-08-23',
    schedule: SPEYER_SCHEDULE,
  },
  {
    id: 'luhmuehlen-2026',
    name: 'MPS Luhmühlen',
    location: 'Luhmühlen',
    city: 'Luhmühlen',
    dates: '04.–06.09.2026',
    startDate: '2026-09-04',
    endDate: '2026-09-06',
    schedule: LUHMUEHLEN_SCHEDULE,
  },
  {
    id: 'borken-2026',
    name: 'MPS Borken',
    location: 'Borken',
    city: 'Borken',
    dates: '26.+27.09.2026',
    startDate: '2026-09-26',
    endDate: '2026-09-27',
    schedule: BORKEN_SCHEDULE,
  },
];

// Keep DEFAULT_SCHEDULE for backward compatibility
export const DEFAULT_SCHEDULE: DaySchedule[] = RASTEDE_SCHEDULE;

export function getActStatus(act: Act, dayDate: string, now: Date): ActStatus {
  const [day, month, year] = dayDate.split('.').map(Number);
  const [startH, startM] = act.startTime.split(':').map(Number);
  const [endH, endM] = act.endTime.split(':').map(Number);

  const startDate = new Date(year, month - 1, day, startH, startM);
  let endDate = new Date(year, month - 1, day, endH, endM);
  if (endH < startH) {
    endDate = new Date(year, month - 1, day + 1, endH, endM);
  }

  if (now >= startDate && now < endDate) return 'live';
  if (now < startDate) return 'upcoming';
  return 'finished';
}

export function getStageColor(stage: Stage): string {
  switch (stage) {
    case 'Musikarena': return 'badge-musikarena';
    case 'Folkbühne': return 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300';
    case 'Festivalbühne': return 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300';
    case 'Kampfplatz': return 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300';
    case 'Turnierarena': return 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300';
    case 'Kinderbereich': return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300';
    case 'Hinter der Folkbühne': return 'bg-teal-100 text-teal-800 dark:bg-teal-900/40 dark:text-teal-300';
    case 'Am Badehaus': return 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900/40 dark:text-cyan-300';
    case 'Auf dem Gelände': return 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300';
    case 'Marktbühne': return 'badge-markt';
    case 'Bühne der Spielleute': return 'bg-lime-100 text-lime-800 dark:bg-lime-900/40 dark:text-lime-300';
    case 'Auf der Waldwiese': return 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300';
    case 'Auf der Heerlagerwiese': return 'bg-stone-100 text-stone-800 dark:bg-stone-900/40 dark:text-stone-300';
    default: return 'badge-upcoming';
  }
}